module.exports = __webpack_public_path__ + "img/geod_14.dbb89349.jpg";